/**
 * Pipeline Dashboard Component
 * Thin component - all logic delegated to usePipeline hook
 */
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import SubHeaders from '@/components/Headers/SubHeaders'
import { RefreshCw } from 'lucide-react'
import type { TaskWithCustomer } from '../../types/response'
import { usePipeline } from '../../hooks/use-pipeline'
import StatsCards from './StatsCards'

const PipelineDashboard = () => {
    const {
        stats,
        statsLoading,
        tasks,
        pagination,
        params,
        stateComponent,
        columns,
        actions,
        handlePageChange,
        handlePageSizeChange,
        refetchAll,
        t,
    } = usePipeline()

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    { path: '/technical', title: 'Technical' },
                    { path: '/technical/report', title: t('breadcrumb.list') },
                    {
                        path: '/technical/report/pipeline',
                        title: t('pipeline.title'),
                    },
                ]}
                actions={[
                    {
                        label: t('pipeline.refresh'),
                        icon: <RefreshCw className="w-4 h-4" />,
                        onClick: refetchAll,
                    },
                ]}
            />

            <div className="my-2 space-y-2">
                <StatsCards stats={stats} isLoading={statsLoading} />

                <Paper className="space-y-2">
                    {stateComponent || (
                        <DataTableCustomized<TaskWithCustomer>
                            columns={columns}
                            rows={tasks}
                            rowKey={(row) => String(row.id)}
                            size="small"
                            actions={actions}
                            pagination={{
                                page: params.page,
                                pageSize: params.page_size,
                                total: pagination?.total || 0,
                                onPageChange: handlePageChange,
                                onPageSizeChange: handlePageSizeChange,
                                pageSizeOptions: [10, 20, 50, 100],
                            }}
                        />
                    )}
                </Paper>
            </div>
        </>
    )
}

export default PipelineDashboard
